<div class="font-10 cout-portion-pondere" *ngIf="displayCoutsDetails" pTooltip="coût portion pondéré" showDelay="500">
 {{menuCompo.coutPortionPondereEffPrev | currency:'EUR':'symbol':'1.4-4'}}
</div>
